import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Link,
  Box,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Logo from '../../images/logo1.1.png';
import DialogForgotPass from 'pages/signin/dialogForgotPass';
import { contactUsPhone } from 'utils/consts';
import './styles.css';

function DialogPropertyOrUserExists(props) {
  const [open, setOpen] = useState(true);
  const [openDialogForgotPass, setOpenDialogForgotPass] = useState(false);
  const linkAtendimento = `https://api.whatsapp.com/send?phone=${contactUsPhone}&text=Fale%20j%C3%A1%20conosco%20e%20tire%20sua%20d%C3%BAvida%20sobre%20nosso%20sistema%20.`;

  return (
    <>
      <Dialog
        onClick={() => setOpen(false)}
        open={open}
        fullWidth
        maxWidth="md"
      >
        <DialogContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '3rem 5rem',
          }}
        >
          {props.message !== '' ? (
            <Typography
              variant="h5"
              component="span"
              style={{ fontWeight: 'bold' }}
            >
              {props.message}
            </Typography>
          ) : (
            <>
              <Box
                style={{
                  border: '2px solid #E98F0A',
                  padding: '2rem',
                  marginBottom: '1rem',
                }}
              >
                <Typography
                  variant="h6"
                  component="h1"
                  style={{ textAlign: 'center', color: '#FE0505' }}
                  gutterBottom
                >
                  O endereço de e-mail já está sendo utilizado
                </Typography>
                <Typography component="p" gutterBottom>
                  Você indicou que é um cliente novo, mas já existe uma conta
                  com o e-mail
                  {props.email}
                  . Se já tem conta na Greenfy, pode
                  usar o mesmo e-mail e senha para fazer o login no
                  {' '}
                  <Link
                    href="https://app.crevettic.com"
                    target="_blank"
                    style={{
                      color: '#0076C6',

                      textDecoration: 'none',
                    }}
                  >
                    app.crevettic.com
                  </Link>
                  . Utilize o esqueci minha senha ou entre em contato com o
                  atendmento ao cliente.
                </Typography>
              </Box>
              <Typography
                component="span"
                style={{ textAlign: 'start' }}
                gutterBottom
              >
                Você já é cliente?
              </Typography>
              <Typography
                component="a"
                style={{ textAlign: 'start' }}
                gutterBottom
              >
                <RouterLink
                  to="/signin"
                  style={{
                    color: '#0076C6',

                    textDecoration: 'none',
                  }}
                >
                  Fazer Login
                </RouterLink>
              </Typography>
              <Typography
                component="span"
                style={{ textAlign: 'start' }}
                gutterBottom
              >
                <Link
                  onClick={() => setOpenDialogForgotPass((prev) => !prev)}
                  target="_blank"
                  style={{
                    color: '#0076C6',

                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                >
                  Esqueci a minha senha
                </Link>
              </Typography>
              <Typography
                component="span"
                style={{ textAlign: 'start' }}
                gutterBottom
              >
                Você ainda precisa de ajuda?
              </Typography>
              <Typography
                component="span"
                style={{ textAlign: 'start' }}
                gutterBottom
              >
                <Link
                  href={linkAtendimento}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#0076C6',

                    textDecoration: 'none',
                  }}
                >
                  Entre em contato com o Atendimento ao Cliente
                </Link>
              </Typography>
            </>
          )}
        </DialogContent>
      </Dialog>
      {openDialogForgotPass && (
        <DialogForgotPass close={() => setOpenDialogForgotPass(false)} />
      )}
    </>
  );
}

export default DialogPropertyOrUserExists;
